import { AccessRequestActions } from '../actions/index';
import { AccessRequestDetails } from '../access-request.state';
import { createReducer, on } from '@ngrx/store';

export const initialState: AccessRequestDetails = {
    loading: null,
    success: null,
    error: null,
    legalEntityPendingRoles: [],
    sgreAdmin: [],
    customerAdmin: [],
    totalNumber: null
};

export const accessRequestFetchReducer = createReducer(
    initialState,
    on(AccessRequestActions.fetchAccessRequest, (state) => ({
        ...state,
        loading: true,
        success: null,
        error: null,
    })),
    on(AccessRequestActions.fetchAccessRequestSuccess, (state, { payload }) => {
        return {
            ...state,
            ...payload,
            loading: null,
            success: true,
            error: null,
        };
    }),
    on(AccessRequestActions.fetchAccessRequestFail, (state, { payload }) => ({
        ...state,
        loading: null,
        success: null,
        error: payload
    })),
    on(AccessRequestActions.clearAccessRequest, () => ({
        ...initialState
    }))
);
